import { Auth0Client } from '@auth0/auth0-spa-js';

import { AUTH0_CLIENT_OPTIONS } from '@/constants/auth0';

// Client Auth0 unique, transmis à Auth0Provider
const auth0Client = new Auth0Client(AUTH0_CLIENT_OPTIONS);

export default auth0Client;
